<template>
    <div  class="tableboxs">
        <el-table v-loading="loading" :data="tableData" @selection-change="handleSelectionChange" height="100%" style="width: 100%" ref="tabsl">
			<el-table-column v-if="config.isSelection" type="selection" width="70" align="center"></el-table-column>
			<el-table-column v-for="(el,index) in config.list" :key="index" :prop="el.prop" :class="el.cls" :label="el.label" :width="el.width">
                <template slot-scope="scope" :width="el.width">
                    <img 
                    v-if="el.type=='img'" 
                    class="tableImg"
                     @click="getPreview(scope.row[el.prop])"
                    :src="el.clfn?el.clfn(scope.row):scope.row[el.prop]"/>

                    <span v-else-if="el.type=='checkRidi'">
						<el-radio 
						v-if="el.checkFn?el.checkFn(el,scope.row):true"
						@change="setRiod(el,scope.row)"						
						v-model="el.checkOn" 
						:label="scope.row[el.checkProp]">&nbsp;</el-radio>
					</span>

                    <component v-else-if="el.type=='component'" v-bind:is="el.component" v-model="scope.row"></component>	

                    <div v-else-if="el.type=='tool'">
                        <el-link 
                        class="tool_01"
                        v-for="(el2,index2) in el.btns" 
                        :key="index2" type="primary" 
                        :underline="false" @click="el2.clickFn?el2.clickFn(scope.row,$event):''">
                        {{el2.backLabel?el2.backLabel(scope.row):el2.label}}
                            <input v-if="el2.blurFn" @blur="el2.blurFn" class="btnyc" type="text">
                        </el-link> 

                    </div>		
                    <div v-else-if="el.type=='html'" v-html="el.clfn?el.clfn(scope.row):scope.row[el.prop]"></div>			
                    <div v-else >{{el.clfn?el.clfn(scope.row):(scope.row[el.prop] || '')}}</div>
                </template>
            </el-table-column>			
		</el-table>
        <div class="w" style="text-align: right;background: #FFFFFF;display: flex;justify-content: flex-end; align-items: center;">
			<el-pagination 
                v-if="total" 
                background 
                class="sel-pagin" 
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :current-page="page"
                :page-size="limit"
				:page-sizes="[20,50, 100, 200, 500,1000,2000]"  
                layout="prev, pager, next, sizes,jumper" 
                :total="total">
			</el-pagination>
		</div>
        <div class="maskimg screenContent" v-if="isimgurl" @click="getPreview">
			<img :src="imgurl" alt="暂无图片" style="max-height:500px;">
		</div>
    </div>
</template>

<script>
export default {
    props:{
        config:Object
    },
    data(){
        return {
            imgurl:"",
            isimgurl:false,
            selectedData:[],
            loading:false,
            page: this.$route.path == '/art/item4' ? +sessionStorage.getItem('curPage') : 1,
            limit:20,
            total:0,
            tableData:[],
            parameter_data:{}
        }
    },
    mounted(){
        this.getData();
    },
    watch:{
        selectedData(){
            this.$emit('selectedDatafn',this.selectedData)
        }
    },
    methods:{
        setRiod(obj,v){
			obj.objData = v;
		},
        handleSelectionChange (val) {
           
            this.selectedData = val
        },
        getData(obj){
            this.parameter_data = obj
            if(this.loading){
                this.$message('正在处理请稍后')
                return
            }
            let pr = {
                page:this.page,
                limit:this.limit,
            };
            if(this.config.pr){
                pr = Object.assign(this.config.pr,pr);
            }
            
            if(obj){
                pr = Object.assign(pr,obj)
            }
            if(this.config.getUrlPr){
                pr = Object.assign(this.config.getUrlPr(),pr)           
            }
            this.loading=true;
            if(!this.config.noStop){
                this.$refs.tabsl.bodyWrapper.scrollTop = 0;
            }
            
            this.api[this.config.url](pr).then(da=>{
                this.loading=false;
                if(da=='error'){return}
                window.sessionStorage.setItem('curPage', da.page != 0 ? da.page : 1)
            
                if(this.config.dataCl){
                      
                    da = this.config.dataCl(da)
                }
                this.total = da.total
                this.tableData = da.data

                // 保存当前页
                
            }).catch(()=>{
                this.loading = false
            })
        },
        handleSizeChange(val){         
            this.limit = val;
            this.handleCurrentChange(1); 
        },
        handleCurrentChange(val){
            this.page = val;
            this.getData(this.parameter_data);
        },
        getPreview(url){
            this.imgurl = url;
            this.isimgurl = !this.isimgurl
        },
    },
};
</script>
<style lang='scss' scoped>
.tableboxs{
    height: calc(100% - 100px);
}

.tool_01{
    position: relative;
    margin: 0 2px;
}
.maskimg{
    position: fixed;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 2005;
}
</style>
<style>
.tableImg{
	display: inline-block;
	max-height: 80px;
	max-width:200px;
}
span.tages{
    display: inline-block;
    vertical-align: top;
    padding: 2px 5px;
    margin: 0 8px 5px 0;
    font-size: 12px;
    border-radius: 5px;
    color: #fff;
    background-color: whitesmoke;

    color: #979797;
    border: 1px solid #eaeaea;
 }
 .btnyc{
     cursor: pointer;
     position: absolute;
     top:0;
     left: 0;
     width: 100%;
     height: 100%;
     opacity: 0;
 }
</style>

